var exports = {
  "kL": "x4c3adb35--99b6f6--container",
  "X5": "x4c3adb35--99b6f6--total",
};

module.exports = exports;
